import $ from 'jquery';

export default class OffCanvas {
    constructor() {
        if($('.js-off-canvas__sub-menu-toggle').length) {
            $(".js-off-canvas__sub-menu-toggle").on('click', function () {
                const $this = $(this);

                $this.toggleClass('is-open');
                $this.parent().next().slideToggle();
            });
        };
    };
};
